export default {
  cities: [],
  segments: [],
  ibgeCities: [],
};
